/* Copyright(c) 2019 APSS Media Pvt. Ltd.
*  All Rights Reserved
*/

/*
@author:Sanobar Golandaj
@Description:UI for finish campaign under quick upload campaign
*/

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logoutUser } from '../login/authentication';
import { withRouter } from 'react-router-dom';
import Footer from '../layouts/footer'; 
import Navigation from '../layouts/navPage';

// use for fetch url value
const queryString = require('query-string');
class   FinishQuickUpload extends React.Component
{
    
    constructor(props) {
        super(props)
        // console.log(props)
        this.state = {
            campaignDetails: [],
             campID:'',
          
        }
         this.advertiserTabs=this.advertiserTabs.bind(this);
        this.logChange = this.logChange.bind(this);
       
    }

    advertiserTabs(e){   
         //snehal-task-3850-VAPT URL changes
        e.preventDefault();
        this.props.history.push('/advertiserTabs')
      localStorage.removeItem('activeKey');
     }

    componentDidMount() {
      if(!this.props.auth.isAuthenticated) {
        this.props.history.push('/userLogin');
    }else{

    
//    *Desc Fetch campID from Url
  

  var parsed = queryString.parse(this.props.location.search);
  var advCampID=parsed.advCampID;
  this.setState({advCampID});
//  console.log("Control on react page");
//  console.log(advCampID);


    //   let self = this;
     
    //   fetch("campaign/finishCampaign?campID="+campID+"")
    //     .then(res => res.json())
    //     .then(campaignDetails => self.setState({ campaignDetails: campaignDetails }));
    }
}
    logChange(e) {
          this.setState({[e.target.name]: e.target.value});  
      }
    
    
     render()
 { 
    
    // Description return All details of authentication
       
        // const {isAuthenticated, user} = this.props.auth;
    //     const linkStyle  = {
    //         fontSize: '15px',
    //         color: 'red'
    
    //   };//kiran-4748-removing console warning-no used


//   Fetch campID from Url
  var parsed = queryString.parse(this.props.location.search);
 


    return(
        <div>
        <Navigation/>
        
        <div class="container" style={{marginBottom:"60px",paddingTop:'110px'}}>
        <div class="row">
            
        <div class="col">
             <button class="btn add-button" onClick={this.advertiserTabs} style={{backgroundColor:'#2196f3',borderColor:'#2196f3',float:'right'}}>
             Click here to Edit</button>
                </div>
            
         </div> 
         {/* <br/> */}
                                        
            <div class="card card-signin">
                <div class="card-body">
                <div class="row">
                  
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="col" align="center"><label id="labelsuccessheading" >
                                            Campaign created successfully !!!</label>
                                        </div>
                                         <div class="col" align="center"><label id="labelsuccessheading" >Campaign ID :&nbsp;{ parsed.advCampID} </label></div>
                                        <div class="col" align="center"><label id="labelsuccessheading"  style={{color:'orange'}}>Please <a href='#/' onClick={this.advertiserTabs}>
                                        {/* kiran-4748-removing console warning-added "#/" */}
                                            click here</a> to allocate agency.</label></div>
                                    
                                    
                                       
                </div>
            </div> {/* close of row */}
           
         </div> {/* close of card-body */}
         </div> {/* close of card*/}
         </div> {/* close of container */}
        
    

<Footer/>
</div>
        

);
 }
}

 /**
       * @author Narendra Phadke
       * @param  Description handle the login authentication
       * @return Description return All details of authentication
       */
      FinishQuickUpload.propTypes = {
        logoutUser: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired
    }
  
    const mapStateToProps = (state) => ({
        auth: state.auth
    })

export default connect(mapStateToProps, { logoutUser })(withRouter(FinishQuickUpload));

